// extracted by mini-css-extract-plugin
module.exports = {"noButton":"FormationsModal_noButton__EEEiw"};